module.exports = __webpack_public_path__ + "static/media/lob-5612-banner-group.bed27428.jpg";